export function convertCssGradientToLinearGradient(cssGradient) {
  // Remove the 'linear-gradient(' prefix and the trailing ')'
  const gradientContents = cssGradient.slice(16, -1);

  // Split the contents by comma
  const parts = gradientContents.split(',');

  // The first part is the direction
  const direction = parts.shift();

  // The remaining parts are the color stops
  const colors = parts.map(part => {
    // Split the color and the position
    const [color, position] = part.trim().split(' ');

    // Convert the color from #RRGGBB to rgba
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    const a = position ? parseFloat(position) / 100 : 1;

    return `rgba(${r}, ${g}, ${b}, ${a})`;
  });

  // Convert the direction from degrees to a start and end point
  const angle = parseFloat(direction);
  const radians = ((angle - 45) * Math.PI) / 180.0;
  const start = {x: Math.cos(radians), y: Math.sin(radians)};
  const end = {x: Math.cos(radians + Math.PI), y: Math.sin(radians + Math.PI)};

  // Return the props for the LinearGradient component
  return {
    colors,
    start,
    end,
  };
}
/**
 * 将单个数字格式化为两位数的字符串，例如将9格式化为'09'。
 * @param {number} num - 要格式化的数字。
 * @return {string} 两位数的字符串。
 */
const padTo2Digits = num => {
  return num.toString().padStart(2, '0');
};

/**
 * 将Date对象格式化为YYYYMMDD格式的数字。
 * @param {Date} date - 要格式化的Date对象。
 * @return {number} 格式为YYYYMMDD的日期数字。
 */
const formatDateToYYYYMMDD = date => {
  return parseInt(
    date.getFullYear() +
      padTo2Digits(date.getMonth() + 1) +
      padTo2Digits(date.getDate()),
    10,
  );
};

/**
 * 生成过去7天或30天的日期字符串数组。
 * @param {number} selection - 7 表示过去7天, 30 表示过去30天。
 * @return {number[]} 日期字符串数组，格式为YYYYMMDD。
 */
export const generateFormattedDateSeries = selection => {
  const daysCount = selection || 30;
  const dates = [];

  for (let i = daysCount - 1; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i); // 将日期回溯i天
    dates.push(formatDateToYYYYMMDD(date)); // 添加格式化后的日期到数组
  }

  return dates;
};
